import './kpi-highlighter.scss';

import isNil from 'lodash/isNil';
import { number } from 'prop-types';
import React from 'react';

import { AGGREGATION_LEVEL_COLOR_MAP } from '../constants';

function KpiHighlighter({ value, aggregationLevel, ...rest }) {
  if (isNil(value) || isNil(aggregationLevel)) {
    return null;
  }
  return (
    <div
      className="bg-white text-center h-100 p-1 c-kpi-highlighter"
      style={{
        borderColor: AGGREGATION_LEVEL_COLOR_MAP[aggregationLevel],
      }}
      {...rest}
    >
      {value}
    </div>
  );
}

KpiHighlighter.propTypes = {
  value: number.isRequired,
  aggregationLevel: number.isRequired,
};

export default KpiHighlighter;
